export default {
    namespaced: true,
    state: {
        types: [],
        typesHeader: "",
        typeIds: [],
        typesEnabled: false
    },
    mutations: {
        setTypesData(state, rootState) {
            state.typesHeader = rootState.attractions
                .filter(attraction => {
                    return attraction.hasOwnProperty("TypeHeader");
                })
                .map(filtered => {
                    return filtered.TypeHeader;
                })[0];

            state.types = rootState.attractions
                .filter(attraction => {
                    return attraction.hasOwnProperty("Type");
                })
                .map(filtered => {
                    return filtered.Type;
                })[0];
            if (state.types && state.types.length > 0) {
                state.typesEnabled = true;
            }
        },
        toggleTypeIds(state, status) {
            if (!state.typeIds.includes(status)) {
                state.typeIds.push(status);
            } else if (state.typeIds.includes(status)) {
                state.typeIds = state.typeIds.filter(el => el !== status);
            }
        },
        setTypeValuesFromCookie(state, payload) {
            if (payload.types) {
                state.typeIds = payload.types;
            }
        }
    }
}